<template>
  <div>
    <div style="margin-bottom: 20px;margin-top: 30px">
      <router-view></router-view>
      <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      <el-button size="small" type="danger" icon="el-icon-delete" @click="handleDelete()">批量删除</el-button>
    </div>
    <div style="width:100%;">
      <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection"
        @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true" :page="page"
        @pageChange="handlePagePagination" :isShowRowSelection="true">
        <div slot="operation" slot-scope="{text,record}">
          <el-button size="mini" @click="handleEdit(record)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(record)">删除</el-button>
        </div>
        <div slot="confValue" slot-scope="{text,record,index}">
          <span v-if="record.confKey === 'sys:contact:edit:whitelist'">{{ record.contactWhitelist.join(',') }}</span>
          <span v-else>{{ text }}</span>
        </div>
      </w-table>
      <add-edit-sysconfig v-if="showAddEditDialog" :show-dialog="showAddEditDialog" :selectType="selectType"
        :select-detail="selectDetail" @submit="closeAddEditDialog">
      </add-edit-sysconfig>
      <picture-loading v-if="loading"></picture-loading>
    </div>
  </div>
</template>

<script>
import {sysConfig} from "@/utils/data/tableCol/sysconfig/sysConfig";
import {deleteConfig, getConfigPage} from "@/api/dilivery/sysconfig";
import AddEditSysconfig from "@/components/sysconfig/AddEditSysconfig.vue";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import { record } from "@/utils/data/tableCol/record/record";



export default {
  name: "SysConfig",
  components: {PictureLoading, TableHeadNote, AddEditSysconfig},
  data() {
    return {
      ids: [],
      showAddEditDialog:false,
      selectDetail: '',
      selectType: {},
      searchConditionTag: [],//搜索tag
      sortConditionTag: [],
      tableData: [],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      deleterInfo: {},
      showDeleteDialog: false,
      loading:true
    }
  },
  computed: {
    columns() {
      this.cols = sysConfig(this.searchConditionTag || {});
      return JSON.parse(JSON.stringify(this.cols))
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    //表格的选择框
    rowSelection(selectedRows) {
      this.ids = selectedRows.map(item => item.id)
    },
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    // 获取数据
    getData(type) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (type) {
        params['page.current'] = 1
        params['page.size'] = 10
      }
      this.sortConditionTag.forEach(item => {
        params["order"] = item.colName + "." + item.order
      })
      let sendData = {}
      sendData = this.getSearch(sendData)
      getConfigPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        sendData["query#" + item.key + ".LIKE"] = item.value
      })
      return sendData
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    //编辑表格显示列
    handleEdit(row) {
      if (row !== undefined && row !== 'undefined') {
        this.selectDetail = row
        this.selectType = {
          type: 'edit',
        }
      } else {
        this.selectType = {
          type: 'add',
        }
        this.selectDetail = ''
      }
      this.showAddEditDialog = true
    },
    closeAddEditDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showAddEditDialog = false
      });
    },
    //删除
    handleDelete(row) {
      let ids = []
      if (row && row.id) {
        ids.push(row.id)
      } else {
        if (this.ids.length > 0) {
          ids = this.ids
        } else {
          this.$messageUi.error('请勾选要批量删除的数据')
          return
        }
      }
      this.$confirmUi('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        let param = {
          "ids" : ids.join(',')
        }
        deleteConfig(param).then(res => {
          if (res.code === 200) {
            this.$messageUi({
              type: 'success',
              message: '删除成功!'
            })
            this.ids = []
            const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize)
            this.page.currentNum = this.page.currentNum > totalPage ? totalPage : this.page.currentNum
            this.page.currentNum = this.page.currentNum < 1 ? 1 : this.page.currentNum
            this.getData()
          }
        }).catch(err => {
        })
      }).catch(() => {

      })
    },
  }
}
</script>

<style scoped>

</style>
